export default "__VITE_ASSET__D1kXkuGj__"